import { TimelineMax, Back } from 'gsap/TweenMax'
import SplitText from '../gsap/src/bonus-files-for-npm-users/SplitText'

function splitTitleAnimation(target) {
  const tl = new TimelineMax()
  const mySplitText = new SplitText(target, { type: 'words,chars' })
  const characters = mySplitText.chars // an array of all the divs that wrap each character

  tl.staggerFrom(characters, 2.8, { opacity: 0, ease: Back.easeOut }, 0.1)
}

export default splitTitleAnimation
